function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const FirebaseIcon = _ref => {
  let {
    size = 16,
    bg = '#FFCA28',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.2 20.9L8.3.6c.1-.3.4-.6.8-.6.3 0 .5.2.6.4l3.4 6.4-7.9 14.1zm22.4 4.9l-3-18.7c-.1-.3-.4-.6-.7-.6-.2 0-.4.1-.5.2l-19 19.1 10.5 5.9c.3.2.7.3 1.1.3.4 0 .8-.1 1.1-.3l10.5-5.9zM19.1 9.5l-2.4-4.6c-.1-.2-.4-.4-.6-.4s-.5.2-.6.4L4.7 24 19.1 9.5z"
  }));
};
export default FirebaseIcon;